const CONFIG = {
    //生产环境配置
    production: {
        debug: true,  //调试信息
        assetsPath: '/static', // 静态资源路径
        baseUrl: 'https://www.nexcontfood.com',  // 后台接口请求地址
        hostUrl: 'https://www.nexcontfood.com',        // H5地址(前端运行地址)
        // hostUrl: 'https://cps.hxq123456.com',        // H5地址(前端运行地址)

        uploadImageUrl: 'https://www.nexcontfood.com/api/v3/common/upload/uploadImage' ,// 上传图片地址
        uploadAnnexUrl: 'https://www.nexcontfood.com/api/v3/common/upload/uploadAnnex' ,// 上传图片地址
        agreement: 'https://www.nexcontfood.com/api/v2/h5/help/agreement',
        privacy: 'https://www.nexcontfood.com/api/v2/h5/help/privacy',
        h5DebugUid: 100011, //100011 哈皮人 5 100040
    },

    development: {
        debug: true,  //调试信息
        assetsPath: '/static', // 静态资源路径
        baseUrl: 'http://localhost:8080',  // 后台接口请求地址
        // baseUrl: 'http://localhost:8080',  // 后台接口请求地址
        // baseUrl: 'http://localhost:8080',  // 后台接口请求地址
        // hostUrl: 'https://cps.hxq123456.com',
        hostUrl: 'https://www.nexcontfood.com',        // H5地址(前端运行地址)
        // hostUrl: 'http://localhost:8080',        // H5地址(前端运行地址)
        // hostUrl: 'https://cps.hxq123456.com',        // H5地址(前端运行地址)

        uploadImageUrl: 'http://localhost:8080/api/v3/common/upload/uploadImage' ,// 上传图片地址
        uploadAnnexUrl: 'http://localhost:8080/api/v3/common/upload/uploadAnnex' ,// 上传图片地址
        agreement: 'https://cps.hxq123456.com/api/v2/h5/help/agreement',
        privacy: 'https://cps.hxq123456.com/api/v2/h5/help/privacy',
        h5DebugUid: 100011, //100011 哈皮人 5 100040
    },

};
let env = process.env.NODE_ENV;
if (env === 'development') {
    // env = "development";
    env = "production";
} else if (process.env.NODE_ENV === 'production') {
    env = "production";
}
export default CONFIG[env];
